/**
 * デバッグ用画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import DebugHome from '../views/debug/DebugHome.vue'
import DebugEditor from '../views/debug/DebugEditor.vue'
import InputSample from '../views/debug/InputSample.vue'
import DrawSample from '../views/debug/DrawSample.vue'

/**
 * デバッグ用ページ群
 */
const debugRoutes: Array<RouteConfig> = [
  // デバッグ用ホーム画面
  {
    path: '/debug',
    name: 'DebugHome',
    component: DebugHome,
  },
  // HTMLエディタ用デバッグ画面
  {
    path: '/debug/editor',
    name: 'DebugEditor',
    component: DebugEditor,
  },
  // 演習画面入力サンプル
  {
    path: '/debug/input',
    name: 'DebugInput',
    component: InputSample,
  },
  // 演習画面入力サンプル
  {
    path: '/debug/draw',
    name: 'DebugDraw',
    component: DrawSample,
  },
]

export default debugRoutes
